module.exports = __webpack_public_path__ + "images/skewness-05-desktop.png";